<ul class="no-decoration">
	<li>
		<a class="twitter" href="https://twitter.com/ericangeless" target="_blank">
			Twitter
		</a>
	</li>
	<li>
		<a class="github" href="https://github.com/erangeles/techstack" target="_blank">
			GitHub
		</a>
	</li>
	<li>
		<a class="linkedin" href="https://www.linkedin.com/in/eric-a-98265613b/" target="_blank">
			LinkedIn
		</a>
	</li>
</ul>
